/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_Crons_DetailInputs */

const en_marketing_binding_crons_detail = /** @type {(inputs: Marketing_Binding_Crons_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled jobs, registered in code and merged into the deploy.`)
};

const es_marketing_binding_crons_detail = /** @type {(inputs: Marketing_Binding_Crons_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos programados, registrados en el código e incorporados al despliegue.`)
};

const fr_marketing_binding_crons_detail = /** @type {(inputs: Marketing_Binding_Crons_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches planifiées, déclarées dans le code et intégrées au déploiement.`)
};

/**
* | output |
* | --- |
* | "Scheduled jobs, registered in code and merged into the deploy." |
*
* @param {Marketing_Binding_Crons_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_crons_detail = /** @type {((inputs?: Marketing_Binding_Crons_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_Crons_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_crons_detail(inputs)
	if (locale === "es") return es_marketing_binding_crons_detail(inputs)
	return fr_marketing_binding_crons_detail(inputs)
});